import React, { useState, useEffect } from 'react';
import { spotlightService } from '../services/api';
import { MapPin, ChevronRight, Map } from 'lucide-react';
import { Link } from 'react-router-dom';

function LocalSpotlight({ isStandalone = false }) {
  const [spotlights, setSpotlights] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadSpotlights();
  }, []);

  const loadSpotlights = async () => {
    try {
      const res = await spotlightService.index({ active_only: 1 });
      setSpotlights(res.data || []);
    } catch (error) {
      console.error('Error loading spotlights:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading || spotlights.length === 0) return null;

  const content = (
    <div className={`${isStandalone ? 'max-w-7xl mx-auto px-4' : ''}`}>
      <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
        <div>
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-red-50 text-red-600 text-xs font-black uppercase tracking-widest mb-4">
            <Map size={14} /> Local Spotlight
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-slate-900 leading-tight">
            Exclusive Offers in <br/><span className="text-red-600">Your Neighborhood</span>
          </h2>
        </div>
        <p className="text-slate-500 max-w-md text-sm leading-relaxed">
          Discover location-specific promotions, store openings, and special events happening near you.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {spotlights.slice(0, 2).map((item) => (
          <div key={item.id} className="group relative overflow-hidden rounded-3xl bg-slate-900 aspect-[16/9] md:aspect-auto md:h-[400px]">
            {item.image_url ? (
              <img 
                src={item.image_url} 
                alt={item.title} 
                className="absolute inset-0 w-full h-full object-cover opacity-60 transition-transform duration-700 group-hover:scale-105" 
              />
            ) : (
              <div className="absolute inset-0 bg-gradient-to-br from-red-900 to-slate-900" />
            )}
            
            <div className="absolute inset-0 bg-gradient-to-t from-slate-950 via-slate-950/20 to-transparent" />
            
            <div className="absolute inset-0 p-8 flex flex-col justify-end">
              <div className="flex items-center gap-2 text-red-400 font-black text-[10px] uppercase tracking-[0.2em] mb-3">
                <MapPin size={14} />
                {item.city}, {item.state}
              </div>
              <h3 className="text-2xl md:text-3xl font-black text-white mb-3 leading-tight group-hover:text-red-400 transition-colors">
                {item.title}
              </h3>
              <p className="text-slate-300 text-sm max-w-sm mb-6 line-clamp-2">
                {item.description}
              </p>
              <div className="flex">
                <Link 
                  to={item.link_url || '/shop'} 
                  className="inline-flex items-center gap-2 bg-white text-slate-900 px-6 py-3 rounded-xl font-bold text-sm hover:bg-red-500 hover:text-white transition-all shadow-xl"
                >
                  View Offer <ChevronRight size={18} />
                </Link>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );

  if (!isStandalone) return content;

  return (
    <section className="py-20 bg-white">
      {content}
    </section>
  );
}

export default LocalSpotlight;
